import API from "@/services/api";
import { Address, IPoblacioINE, IProvincia, ITipovias } from "../types/address";

enum Endpoints {
  Poblacions = "/geo/zipcode/:zipcode/",
  Provincies = "/geo/provincies/:ine/",
  Tipovias = "/geo/tipovias/"
}

const fetchPoblacionsINE = (
  zipcode: string
) => {
  return new Promise<IPoblacioINE[]>(async (resolve, reject) => {
    API.get<IPoblacioINE[]>({
      endpoint: Endpoints.Poblacions,
      params: {
        zipcode
      },
      versions: [1]
    })
    .then(res => {
      resolve(res.promise.data)
    })
    .catch(err => {
      reject(err);
    })
  })
}

const fetchProvincies = (
  stateCode: string
) => {
  return new Promise<IProvincia[]>(async (resolve, reject) => {
    API.get<IProvincia[]>({ // fix this
      endpoint: Endpoints.Provincies,
      params: {
        ine: stateCode
      },
      versions: [1]
    })
    .then(res => {
      resolve(res.promise.data)
    })
    .catch(err => {
      reject(err);
    })
  })
}

const fetchTipovias = () => {
  return new Promise<ITipovias[]>(async (resolve, reject) => {
    API.get<ITipovias[]>({
      endpoint: Endpoints.Tipovias,
      versions: [1]
    })
    .then(res => {
      resolve(res.promise.data)
    })
    .catch(err => {
      reject(err);
    })
  })
}

export default {
  fetchPoblacionsINE,
  fetchProvincies,
  fetchTipovias
};


